import React, { useRef, Component } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon, BookOpenIcon, ClockIcon, DropletIcon, MessageSquareIcon, HomeIcon, BackpackIcon } from 'lucide-react';
import { WaveDivider } from './WaveDivider';
export function WhatYouGet() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const items = [{
    icon: BookOpenIcon,
    title: 'La Guía Digital Completa',
    description: 'El manual táctico para dominar la ansiedad laboral.'
  }, {
    icon: ClockIcon,
    title: 'Técnicas de 10 Segundos',
    description: 'Cómo frenar una taquicardia sin moverte de tu puesto.'
  }, {
    icon: DropletIcon,
    title: 'Protocolo de Reseteo en el Baño',
    description: 'El uso del agua fría para "apagar" el pánico mecánicamente.'
  }, {
    icon: MessageSquareIcon,
    title: 'El Guión de Salida',
    description: 'Las 5 palabras exactas para ganar tiempo profesionalmente cuando sientes que vas a llorar.'
  }, {
    icon: HomeIcon,
    title: 'Ritual del Umbral',
    description: 'Cómo dejar el estrés en la puerta de tu casa para volver a ser el padre/madre que tu familia merece.'
  }, {
    icon: BackpackIcon,
    title: 'Checklist de Mochila',
    description: 'Tu kit de $2 para "curar" tu cara tras una crisis y que nadie sospeche nada.'
  }];
  return <section className="bg-slate-50 relative" data-id="element-135">
      <div ref={ref} className="py-16 md:py-24 px-4" data-id="element-136">
        <div className="max-w-4xl mx-auto" data-id="element-137">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6
        }} className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#0f1b2d] text-center mb-12" data-id="element-138">
            Lo Que Recibes
          </motion.h2>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-139">
            {items.map((item, index) => {
            const IconComponent = item.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 30
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {}} transition={{
              duration: 0.5,
              delay: 0.1 + index * 0.1
            }} className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-140">
                  <div className="flex items-start gap-4" data-id="element-141">
                    <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-[#3d7a8a] to-[#6aacb8] rounded-lg flex items-center justify-center" data-id="element-142">
                      <IconComponent className="w-6 h-6 text-white" data-id="element-143" />
                    </div>
                    <div className="flex-1" data-id="element-144">
                      <div className="flex items-center gap-2 mb-2" data-id="element-145">
                        <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-146" />
                        <h3 className="font-bold text-[#0f1b2d] text-lg" data-id="element-147">
                          {item.title}
                        </h3>
                      </div>
                      <p className="text-gray-600 leading-relaxed" data-id="element-148">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>

      <WaveDivider fillColor="#0f1b2d" data-id="element-149" />
    </section>;
}